var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMyagentsIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06189 9C2.55399 5.05369 5.92038 2 10 2V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V2.06189C14.6187 2.51314 17.4869 5.38128 17.9381 9H16.5C16.2239 9 16 9.22386 16 9.5C16 9.77614 16.2239 10 16.5 10H18C18 14.0796 14.9463 17.446 11 17.9381V16.5C11 16.2239 10.7761 16 10.5 16C10.2239 16 10 16.2239 10 16.5V18C5.58172 18 2 14.4183 2 10H3.5C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9H2.06189ZM12.1571 9.47758C11.8431 8.74501 11.2505 8.16749 10.5102 7.87246L7.02486 6.48362C6.68504 6.3482 6.34813 6.68511 6.48356 7.02493L7.87246 10.5102C8.1675 11.2505 8.74502 11.8431 9.47756 12.157L13.2092 13.7563C13.5549 13.9045 13.9045 13.5549 13.7563 13.2092L12.1571 9.47758Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMyagentsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/myagents-icon.fec92821.svg";
export { ForwardRef as ReactComponent };